import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWaitListLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 48,
	viewBox: "0 0 64 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M32 24.5L38 3.5",
			stroke: "#A8AAE3",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.5,
			y: .5,
			width: 47,
			height: 47,
			rx: 3.5,
			stroke: "black",
			strokeOpacity: .12
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 23,
			y: 1,
			width: 1,
			height: 46,
			fill: "black",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8174 7.94666L13.98 11.0081C14.2221 11.6458 15.1292 11.6906 15.6615 11.0911L20.1814 6",
			stroke: "#A8AAE3",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 40,
			y: 1,
			width: 1,
			height: 46,
			fill: "black",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 15,
			width: 14,
			height: 1,
			fill: "black",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24,
			y: 15,
			width: 16,
			height: 1,
			fill: "black",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 41,
			y: 15,
			width: 14,
			height: 1,
			fill: "black",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 32,
			width: 14,
			height: 1,
			fill: "black",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24,
			y: 32,
			width: 16,
			height: 1,
			fill: "black",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 41,
			y: 32,
			width: 14,
			height: 1,
			fill: "black",
			fillOpacity: .12
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.4105 19.7152C30.5884 18.0387 35.1963 19.4057 31.3828 22.8102C26.616 27.0658 31.7801 19.715 29.7939 20.8756C27.8077 22.0363 26.2188 25.905 27.4105 26.6788C28.6022 27.4525 36.1496 19.715 36.9441 21.2625C37.7385 22.81 29.7939 26.2919 30.5883 27.8394C31.3828 29.3869 36.5468 23.5838 36.9441 25.1313C37.2619 26.3693 35.4875 28.2263 34.5607 29",
			stroke: "black",
			strokeOpacity: .12,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.5 3.49988C38.9 3.09988 38.1667 3.66655 38 3.99988L35.5 13.5C36.1667 13.3333 37.8 13 39 13C40.5 13 40 14 44 15.5C44.8206 15.8077 46.7701 16.0387 48.5368 16.0498C49.2024 16.0539 49.5352 16.056 49.8109 15.8373C50.0867 15.6186 50.166 15.2697 50.3246 14.5718L51.6556 8.71516L51.6557 8.71514C52.0122 7.14611 52.1905 6.3616 51.843 5.97624C51.4954 5.59089 50.6006 5.69924 48.8111 5.91593C48.3765 5.96856 47.9343 6 47.5 6C45 6 42.5 3.99988 40.5 3.49988Z",
			fill: "#A8AAE3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.5 25.5C28 28 33 29.5 38.5 23",
			stroke: "#A8AAE3",
			strokeLinecap: "round"
		})
	]
});
export default SvgWaitListLight;
